import i18next from 'i18next';

export const mccCodes = {
  // Agricultural Services
  742: "Veterinary Services",
  763: "Agricultural Co-operatives",
  780: "Landscaping and Horticultural Services",

  // Contracted Services
  1520: "General Contractors",
  1711: "Heating, Plumbing, A/C",
  1731: "Electrical Contractors",
  1740: "Masonry, Stonework",
  1750: "Carpentry",
  1761: "Roofing, Siding",
  1771: "Concrete Work",
  1799: "Special Trade Contractors",
  2741: "Publishing and Printing",
  2791: "Typesetting",
  2842: "Specialty Cleaning",

  // Transportation
  4111: "Commuter Transport",
  4112: "Passenger Railways",
  4119: "Ambulance Services",
  4121: "Taxi/Limo",
  4131: "Bus Lines",
  4214: "Trucking/Moving",
  4215: "Courier Services",
  4411: "Cruise Lines",
  4457: "Boat Rentals",
  4468: "Marinas",
  4511: "Airlines",
  4582: "Airports",
  4722: "Travel Agencies",
  4784: "Tolls/Bridge Fees",
  4789: "transportation Services",
  7512: "Car Rental",
  7523: "Parking",
  7531: "Auto Body Repair",
  7538: "Auto Service",
  7542: "Car Washes",
  7549: "Towing",

  // Utilities
  4812: "Telecom Equipment",
  4814: "Telecom Services",
  4816: "Computer Network Services",
  4821: "Telegraph",
  4899: "Cable/Satellite/Radio",
  4900: "Utilities (Electric/Gas/Water)",

  // Retail
  5045: "Computers/Software",
  5193: "Florist Supplies",
  5200: "Home Supply Warehouse",
  5211: "Building Materials",
  5251: "Hardware Stores",
  5300: "Wholesale Clubs",
  5310: "Discount Stores",
  5311: "Department Stores",
  5331: "Variety Stores",
  5411: "Grocery Stores",
  5422: "Meat Provisioners",
  5441: "Candy/Nut/Confectionery",
  5451: "Dairy Products",
  5462: "Bakeries",
  5499: "Misc Food Stores",
  5511: "Car/Truck Dealers",
  5532: "Tire Stores",
  5533: "Auto Parts",
  5541: "Service Stations",
  5542: "Fuel Dispensers",
  5611: "Men's Clothing",
  5621: "Women's Clothing",
  5631: "Women's Accessories",
  5641: "Children's Clothing",
  5651: "Family Clothing",
  5655: "Sports Apparel",
  5661: "Shoe Stores",
  5691: "Men's/Women's Clothing",
  5699: "Misc Apparel",
  5712: "Furniture/Home Equipment",
  5719: "Misc Home Furnishing",
  5722: "Appliance Stores",
  5732: "Electronics",
  5734: "Computer Software",
  5811: "Caterers",
  5812: "Restaurants",
  5813: "Bars/Clubs",
  5814: "Fast Food",
  5912: "Drug Stores/Pharmacies",
  5921: "Liquor Stores",
  5931: "Used Merchandise",
  5941: "Sporting Goods",
  5942: "Book Stores",
  5943: "Stationery/Office Supplies",
  5944: "Jewelry/Watch/Silverware",
  5945: "Hobby/Toy/Game",
  5946: "Camera/Photo",
  5947: "Gift/Card/Novelty",
  5948: "Luggage/Leather",
  5949: "Fabric/Sewing",
  5950: "Glassware/Crystal",
  5964: "Direct Marketing (Catalog)",
  5965: "Direct Marketing (Combo)",
  5967: "Direct Marketing (Inbound Tele)",
  5968: "Direct Marketing (Subscription)",
  5969: "Direct Marketing (Other)",
  5976: "Orthopedic Goods",
  5977: "Cosmetic Stores",
  5983: "Fuel Dealers",
  5992: "Florists",
  5993: "Misc stores",
  5994: "Newsstands",
  5995: "Pet Shops",
  5999: "Misc Retail",

  // Service Providers
  6010: "Financial Inst (Manual Cash)",
  6011: "Financial Inst (Auto Cash)",
  6012: "Financial Inst (Merchandise)",
  6300: "Insurance",
  6513: "Real Estate Agents",
  7011: "Hotels/Motels/Resorts",
  7210: "Laundry/Cleaning",
  7211: "Laundry Services",
  7216: "Dry Cleaners",
  7221: "Photo Studios",
  7230: "Barber/Beauty Shops",
  7298: "Health/Beauty Spas",
  7311: "Advertising",
  7399: "Business Services",
  7832: "Movie Theaters",
  7922: "Theatrical Producers",
  7991: "Tourist Attractions",
  7995: "Betting/Lottery/Casino",
  7996: "Amusement Parks",
  7997: "Clubs/Golf Courses",
  7999: "Recreation Services",
  8011: "Doctors",
  8021: "Dentists",
  8043: "Opticians",
  8062: "Hospitals",
  8071: "Medical Labs",
  8099: "Medical Services",
  8211: "Schools (Elem/Sec)",
  8220: "Colleges/Universities",
  8299: "Schools (Misc)",
  8398: "Charity/Social Service",
  8641: "Civic/Social Assoc",
  8699: "Membership Org",
  8999: "Professional Services",
  9211: "Court Costs",
  9222: "Fines",
  9311: "Tax Payments",
  9399: "Government Services",
};

export const getMccDescription = (code) => {
  const key = `mcc.${code}`;
  const translated = i18next.t(key);
  if (translated !== key) return translated;
  return mccCodes[code] || "Unknown Category";
};

export default mccCodes;
